const getters = {
  getTradePlanList(state) {
    return state.tradePlanList;
  },
  getTradePlan(state) {
    return state.tradePlan;
  },
  getTradePlanDeatilData(state) {
    return state.tradePlanDetail;
  },
  getBudgetHeadGridData(state) {
    return state.budgetHeadGridData;
  },
  getBudgetHeadList(state) {
    return state.budgetHeadList;
  },
  getSalesDetailsList(state) {
    return state.salesDetails;
  },
  getSalesDeductionPlanList(state) {
    return state.salesDeductionPlan;
  },
  getPlanDeatilList(state) {
    return state.planDetailList;
  },
  getNetSaleslList(state) {
    return state.netSalesList;
  },
  getBudgetHeadObject(state) {
    return state.budgetHeadObject;
  },
};

export default getters;
